<template>
  <div class="ed-aside-menu">

    <div class="ed-aside-menu__page from-left">
      <div class="ed-aside-menu__previous" v-show="parentPage !== 'asideHome'" @click="backHome"><span class="icon-back-button-white"></span>Accueil</div>
      <div v-show="parentPage !== 'asideHome'" class="ed-aside-menu__path-container">
        >
        <span v-for="(item, index) in path">
          <div class="ed-aside-menu__path" :class="{ 'no-link' : !item.id, 'current': folder.id === item.id }" v-html="item.name"></div>
          <span v-show="index < path.length - 1">/</span>
        </span>
      </div>
      <ul class="ed-aside-menu__list">
        <li v-for="child in newFolders">
          <dropdown-menu :name="child.name" v-if="child.listId" :id='"asideSubMenu" + child.id'>
            <dropdown-menu-content v-if="subMenuList(child.listId)">
              <dropdown-menu-item v-for="link in subMenuList(child.listId).redirections" key="submenu">
                {{ link.name }}
              </dropdown-menu-item>
            </dropdown-menu-content>
          </dropdown-menu>
          <div class="ed-aside-menu__link" v-html="child.name" v-else></div>
        </li>
      </ul>
    </div>

    <div class="ed-aside-menu__page main-page" :id="parentPage">
      <div class="ed-aside-menu__previous" v-show="parentPage !== 'asideHome'" @click="backHome"><span class="icon-back-button-white"></span>Accueil</div>
      <div v-show="parentPage !== 'asideHome'" class="ed-aside-menu__path-container">
        >
        <span v-for="(item, index) in path">
          <div class="ed-aside-menu__path" @click="asideMenuAnimation(item.id, parentPage)" :class="{ 'no-link' : !item.id, 'current': parentPage === item.id }" v-html="item.name"></div>
          <span v-show="index < path.length - 1">/</span>
        </span>
      </div>
      <ul class="ed-aside-menu__list">
        <li v-for="child in asideCurrentFolders">
          <dropdown-menu :name="child.name" v-if="child.listId" :id='"asideSubMenu" + child.id'>
            <dropdown-menu-content v-if="subMenuList(child.listId)">
              <dropdown-menu-item v-for="link in subMenuList(child.listId).redirections" @click.native="asideMenuAnimation(link.id, child.parent, child.id)" key="submenu">
                {{ link.name }}
              </dropdown-menu-item>
            </dropdown-menu-content>
          </dropdown-menu>
          <div class="ed-aside-menu__link"
          @click="if (child.triggerView) { child.triggerView(child.id) } else { asideMenuAnimation(child.id, child.parent); }"
          v-html="child.name" :class="{ 'active': child.id === activePanel }" v-else></div>
        </li>
      </ul>
    </div>

    <div class="ed-aside-menu__page from-right" :id="parentPage">
      <div class="ed-aside-menu__previous" v-show="parentPage !== 'asideHome'" @click="backHome"><span class="icon-back-button-white"></span>Accueil</div>
      <div v-show="parentPage !== 'asideHome'" class="ed-aside-menu__path-container">
        >
        <span v-for="(item, index) in path">
          <div class="ed-aside-menu__path" :class="{ 'no-link' : !item.id, 'current': folder.id === item.id }" v-html="item.name"></div>
          <span v-show="index < path.length - 1">/</span>
        </span>
      </div>
      <ul class="ed-aside-menu__list from-right">
        <li v-for="child in newFolders">
          <dropdown-menu :name="child.name" v-if="child.listId" :id='"asideSubMenu" + child.id'>
            <dropdown-menu-content v-if="subMenuList(child.listId)">
              <dropdown-menu-item v-for="link in subMenuList(child.listId).redirections" key="submenu">
                {{ link.name }}
              </dropdown-menu-item>
            </dropdown-menu-content>
          </dropdown-menu>
          <div class="ed-aside-menu__link" v-html="child.name" v-else></div>
        </li>
      </ul>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'edAsideMenu',
    data() {
      return {
        path: [],
        newFolders: [],
        parentPage: this.parentPageInit,
        asideCurrentFolders: this.folders,
      };
    },
    props: {
      folders: Array,
      submenus: Array,
      activePanel: String,
      clickFunction: Function,
      noChildFunction: Function,
      parentPageInit: String,
    },
    watch: {
      path() {
        this.$parent.$parent.$data.asidePath = this.path;
      }
    },
    methods: {
      /* Function to move between aside pages and update the path */
      asideMenuAnimation(directionId) {
        console.log('in move function');
        console.log(directionId);
        this.newFolders = this.clickFunction(directionId);
        console.log(this.newFolders);
        if (this.newFolders.length) {
          this.pageMovementLeft();
          this.parentPage = directionId;
        } else {
          this.noChildFunction(directionId);
        }
      },

      pageMovementLeft() {
        document.getElementsByClassName('from-right')[0].className += ' active';
        document.getElementsByClassName('ed-aside-menu__page main-page')[0].className += ' moving-left';
        document.getElementsByClassName('ed-aside-menu__page main-page')[0].className += ' hidden-page';
        document.getElementsByClassName('ed-aside-menu__page main-page')[0].classList.remove('moving-left');
        setTimeout(() =>  {
          this.asideCurrentFolders = this.newFolders;
          document.getElementsByClassName('ed-aside-menu__page main-page')[0].classList.remove('hidden-page');
          document.getElementsByClassName('from-right')[0].className += ' hidden-page';
          document.getElementsByClassName('from-right')[0].classList.remove('active');
          this.newFolders = [];
        }, 300);
        setTimeout(() => {
          document.getElementsByClassName('from-right')[0].classList.remove('hidden-page');
        }, 400);
      },

      pageMovementRight() {
        document.getElementsByClassName('from-left')[0].className += ' active';
        document.getElementsByClassName('ed-aside-menu__page main-page')[0].className += ' moving-right';
        document.getElementsByClassName('ed-aside-menu__page main-page')[0].className += ' hidden-page';
        document.getElementsByClassName('ed-aside-menu__page main-page')[0].classList.remove('moving-right');
        setTimeout(() =>  {
          this.asideCurrentFolders = this.newFolders;
          document.getElementsByClassName('ed-aside-menu__page main-page')[0].classList.remove('hidden-page');
          document.getElementsByClassName('from-left')[0].className += ' hidden-page';
          document.getElementsByClassName('from-left')[0].classList.remove('active');
          this.newFolders = [];
        }, 300);
        setTimeout(() => {
          document.getElementsByClassName('from-left')[0].classList.remove('hidden-page');
        }, 400);
      },



/*      updatePath() {

      },*/

      backHome() {
        this.newFolders = this.folders;
        this.pageMovementRight();
        this.parentPage = this.parentPageInit;
        /* Gets all pages in the document */
        /*const asideMenuPages = document.getElementsByClassName('ed-aside-menu__page');
        for (let i = 0; i < asideMenuPages.length; i += 1) {*/
          /* Puts all pages in initial state */
          /*asideMenuPages[i].classList.remove('hidden');
          asideMenuPages[i].classList.remove('active');*/
       // }
        /* Lets the home active */
        /* document.getElementById('asideHome').className += ' active';*/
        /* Lets the path empty */
        /* this.path = [];
        const homeIndex = this.asideCurrentFolders.findIndex(elmt => elmt.id === 'asideHome');
        this.path.push(this.asideCurrentFolders[homeIndex]);*/
      },

      /* Function to get the submenu list linked to a dropdown folder */
      subMenuList(listId) {
        if (this.submenus) {
          for (let i = 0; i < this.submenus.length; i += 1) {
            if (this.submenus[i].id === listId) {
              return this.submenus[i];
            }
          }
        }
        return false;
      },

      /* Function to know if a folder is part of a dropdown menu list */
      submenusChildFilter(folderId) {
        /* Browse the submenus list */
        if (this.submenus) {
          for (let index = 0; index < this.submenus.length; index += 1) {
            /* Browse every items */
            for (let redirection = 0; redirection < this.submenus[index]
              .redirections.length; redirection += 1) {
              /* If the targeted folder actually belongs to a dropdown list ... */
              if (this.submenus[index].redirections[redirection].id === folderId) {
                /* ... it is not gonna be added to the list */
                return false;
              }
            }
          }
        }
        return true;
      },

    },
    mounted() {

    }
  };
</script>


// WEBPACK FOOTER //
// edAsideMenu.vue?af245b7e